import { getFeatureData } from 'config-request';
import { CategoryCode, FeatureType, SubCategoryCode, } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { useFeatureListStore } from './feature-list';
import { useGlobalStore } from './global';
import { usePriceListStore } from './price-list';
export const useKeysStore = defineStore('keys', {
    getters: {
        keysList() {
            const featureListStore = useFeatureListStore();
            if (!featureListStore.data)
                return [];
            const keyCodeList = [
                CategoryCode.Cockpit,
                SubCategoryCode.Key,
                FeatureType.CockpitKey,
            ];
            const featureItem = getFeatureData(keyCodeList, featureListStore.data);
            return (featureItem?.option_list?.map((option) => featureListStore.data?.option_map[option]) ?? []);
        },
        currentKeyData() {
            const globalStore = useGlobalStore();
            const featureList = useFeatureListStore();
            const priceList = usePriceListStore();
            if (!featureList.data)
                return null;
            const optionData = featureList.data.option_map[globalStore.currentOptions.F00020];
            const priceDiscountTip = priceList.data?.configurator_select_discount_tip_map?.[globalStore.currentOptions.F00020] || '';
            const priceDiscountTipIcon = priceList.data?.configurator_select_discount_tip_icon_map?.[globalStore.currentOptions.F00020] || {
                icon: '',
                icon_ratio: 0,
            };
            const discountData = {
                discount_selected: !!priceDiscountTip,
                discount_tip: priceDiscountTip || optionData?.discount_tip || '',
                discount_tip_icon: priceDiscountTipIcon?.icon || optionData?.discount_tip_icon || '',
                discount_tip_icon_ratio: priceDiscountTipIcon?.icon_ratio || optionData?.discount_tip_icon_ratio || 0,
            };
            // return keyList.find(
            //   (key) => key?.code === globalStore.currentOptions.F00020
            // )
            return {
                ...optionData,
                ...discountData,
            };
        },
    },
});
